import script from "./VinificationStepList.vue?vue&type=script&setup=true&lang=js"
export * from "./VinificationStepList.vue?vue&type=script&setup=true&lang=js"

import "./VinificationStepList.vue?vue&type=style&index=0&id=74da0136&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-74da0136"]])

export default __exports__